/*
 * Dog Meal recipe ingredients panel.
 * Reads the recipe value selected in the [data-recipe-option] fieldset (rendered by
 * snippets/variant-picker.liquid) and shows that recipe's ingredients in the panel
 * rendered by snippets/recipe-ingredients.liquid. Updates live on every change.
 */
(function () {
  if (window.__recipeIngredientsInit) return;
  window.__recipeIngredientsInit = true;

  function scopeOf(panel) {
    return panel.closest('.product-detail') || document;
  }

  function mapFor(panel) {
    var script = scopeOf(panel).querySelector('[data-recipe-ingredients-data]');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      return null;
    }
  }

  function selectedRecipe(panel) {
    var checked = scopeOf(panel).querySelector('[data-recipe-option] input:checked');
    return checked ? checked.value : '';
  }

  // Variant values can be bilingual (e.g. "Beef Bison * Bœuf Bison"), so match by
  // checking which recipe name the selected value contains.
  function matchKey(map, value) {
    if (!value) return null;
    var keys = Object.keys(map);
    for (var i = 0; i < keys.length; i++) {
      if (value.indexOf(keys[i]) > -1) return keys[i];
    }
    return null;
  }

  function sync(panel) {
    var map = mapFor(panel);
    var list = panel.querySelector('[data-recipe-ingredients-list]');
    var key = map ? matchKey(map, selectedRecipe(panel)) : null;
    var items = key ? map[key] : null;

    if (!list || !items || !items.length) {
      panel.hidden = true;
      return;
    }

    list.innerHTML = '';
    items.forEach(function (name) {
      var li = document.createElement('li');
      li.textContent = name;
      list.appendChild(li);
    });
    panel.hidden = false;
  }

  function syncAll() {
    var panels = document.querySelectorAll('[data-recipe-ingredients]');
    Array.prototype.forEach.call(panels, sync);
  }

  // Re-evaluate after any option change. setTimeout lets the theme's variant picker
  // update the checked radio first.
  document.addEventListener('change', function () { setTimeout(syncAll, 0); });

  if (document.readyState !== 'loading') syncAll();
  else document.addEventListener('DOMContentLoaded', syncAll);
})();
